import Assessment from '../assessment';

/**
 * Create the action
 */

const { thunk, request, success, error } = Assessment.index((fetch) =>
  fetch.get('/assessments')
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
